import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { clickToSubmitButtonWithEnter } from "../../Inputs/handleKeyDown";
import { resetPasswordRequest } from "./passwordRecoveryRequests";


function PasswordRecoveryStep3({ theme, setTheme }) {

    const { t } = useTranslation();

    const passwordInputRef = useRef(null);

    const navigate = useNavigate();


    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const [requestStatus, setRequestStatus] = useState({
        loading: false,
        error: null
    });


    useEffect(() => {

        if (passwordInputRef.current) {
            passwordInputRef.current.focus();
        }

        clickToSubmitButtonWithEnter();

    }, []);



    const passwordRecovery = JSON.parse(
        sessionStorage.getItem("passwordRecovery") || "{}"
    );

    const otpId = passwordRecovery.otpId;


    function submitPassword() {
        if (password !== confirmPassword) {

            setRequestStatus({
                loading: false,
                error: "Passwords do not match"
            });

            return;
        }


        resetPasswordRequest(
            password,
            otpId,
            navigate,
            setRequestStatus
        );

    }



    return (

        <div className="signin_main_div">

            <div className="signin_fields_div">

                <div className="signin_title_div">
                    {t("Create a new password")}
                </div>


                <div className="input_div">

                    <div>
                        {t("New password")}
                    </div>

                    <input
                        type="password"
                        ref={passwordInputRef}
                        className={`input dir_ltr ${theme} ${requestStatus.error ? "error" : ""}`}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                </div>


                <div className="input_div">

                    <div>
                        {t("Confirm password")}
                    </div>

                    <input
                        type="password"
                        className={`input dir_ltr ${theme} ${requestStatus.error ? "error" : ""}`}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                    />

                </div>


                <div className="input_error_div">
                    {requestStatus.error}
                </div>

                <button

                    className={`submit_button ${theme} ${password && confirmPassword ? "active" : ""
                        }`}

                    onClick={
                        password && confirmPassword
                            ? submitPassword
                            : undefined
                    }

                >

                    {
                        requestStatus.loading

                            ?
                            <img
                                src="/icons/loading.png"
                                className="rotate"
                            />

                            :

                            t("Confirm")
                    }

                </button>

            </div>


            <div className="buttons_div_in_signin1">
                <button
                    className={`simple_button ${theme}`}
                    onClick={() => navigate("/signin")}
                >
                    {t("Signin")}
                </button>
            </div>

            <div className="buttons_div_in_signin2">
                <button
                    className={`simple_button fontSize14 ${theme}`}
                    onClick={() => navigate("/rules")}
                >
                    {t("Rules")}
                </button>
                <button className={`simple_button fontSize14 ${theme}`}>{t("Language")}</button>
                <button
                    className={`simple_button fontSize14 ${theme}`}
                    onClick={() => {
                        setTheme(theme === "light" ? "night" : "light");
                    }}
                >
                    {theme === "light" ? t("Night mode") : t("Light mode")}
                </button>
            </div>

        </div>

    );

}


export default PasswordRecoveryStep3;